module.exports = __webpack_public_path__ + "img/sneaker_big.1f255a24.png";